export const OLCS_ION_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJjZGQzZjY0Ny0wZWRhLTRmNTEtYjQwZC1mY2EwMTQ3MjA0ZjkiLCJpZCI6MjE5MjA3LCJpYXQiOjE3MTcxNjk5OTZ9.hV5UTJqe9V7aFLT6mvomf9YL1lYqKJSGceZabbuOQxc';
